import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "tss-react/mui";
import usePageLoader from "../../Redux/hooks/usePageLoader";
import useSnackBar from "../../Redux/hooks/useSnackBar";
import { useLocation, useNavigate } from "react-router-dom";
import CommonAuth from "../../Component/Common/CommonAuth";
import { forgotPassword, otpVerification } from "../../Redux/Actions/AuthUser";
import ErrorHandler from "../../lib/errorHandler";

const useStyles = makeStyles()((theme) => {
    return {
        otpContainer: {
            display: "flex",
            justifyContent: "center",
            gap: "18px",
            marginTop: "1rem",
            [theme.breakpoints.down(426)]: {
                gap: "12px",
            },
        },
        otpInput: {
            width: "100%",
            height: "57px",
            textAlign: "center",
            fontSize: "24px",
            fontFamily: "Gilroy, arial !important",
            fontWeight: 500,
            color: "black",
            backgroundColor: "transparent",
            border: "1px solid #D0D0D0",
            borderRadius: "10px",
            "&:focus": {
                outline: "none",
                backgroundColor: "#f3f4fe",
            },
            [theme.breakpoints.down(750)]: {
                height: "50px",
                fontSize: "20px",
            },
            [theme.breakpoints.down(600)]: {
                height: "45px",
                fontSize: "18px",
            },
            [theme.breakpoints.down(500)]: {
                height: "35px",
                fontSize: "16px",
            },
            [theme.breakpoints.down(425)]: {
                height: "40px",
                fontSize: "16px",
            },
            [theme.breakpoints.down(345)]: {
                height: "30px",
                fontSize: "16px",
            },
        },
    };
});
const OtpVerification = () => {
    // =================== Hooks ===================
    const dispatch = useDispatch();
    const { classes } = useStyles();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const navigate = useNavigate();
    const location = useLocation();

    // =================== States ===================
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [email, setEmail] = useState("");

    // =================== Handler ===================

    const handleBack = () => {
        navigate("/login");
    };

    const handleChange = (element, index) => {
        const value = element.value;
        if (/^[0-9]$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (element.nextSibling && value) {
                element.nextSibling.focus();
            }
        } else if (value === "") {
            const newOtp = [...otp];
            newOtp[index] = "";
            setOtp(newOtp);
            if (element.previousSibling) {
                element.previousSibling.focus();
            }
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const pastedData = event.clipboardData.getData("text");

        if (/^\d{6}$/.test(pastedData)) {
            const newOtp = pastedData.split("").map((digit) => digit.trim());
            setOtp(newOtp);
        } else {
            setSnackBar("error", `Please paste a valid 6-digit OTP`)
        }
    };

    // =================== FotgotPassword API ===================
    const handleOtpVerification = async () => {
        const otpCode = otp.join("");

        if (!/^\d{6}$/.test(otpCode)) {
            setSnackBar("error", `Please enter a valid 6-digit OTP`)
            return;
        }
        setFullPageLoader(true);
        let body = {
            otp: otpCode,
            email: email,
        }
        let response = await dispatch(otpVerification(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setFullPageLoader(false);
            navigate(`/enter-password?token=${btoa(email)}&OTP=${btoa(otpCode)}`);
        } else {
            setSnackBar("error", `No response from the server. Please try again.`)
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };


    // =================== FotgotPassword API ===================
    const handleResendOtp = async () => {
        setFullPageLoader(true);
        let response = await dispatch(forgotPassword({ email: email }));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setFullPageLoader(false);
            setSnackBar("success", `OTP sent successfully`)
            setOtp(new Array(6).fill(""));
        } else {
            setSnackBar("error", `Failed to resend OTP`)
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // =================== Use Effects ===================
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get("token");

        if (token) {
            const decodedEmail = atob(token);
            setEmail(decodedEmail);
        }
    }, [location.search]);

    return (
        <>
            <CommonAuth
                onButtonClick={handleOtpVerification}
                submitButtonName={"Verify"}
                btnMarginTop={{ xs: "2rem", sm: "2rem", md: "2.5rem" }}
                boxShadow={"13px -5px 30px 0px rgba(29, 97, 205, 0.10)"}
                children={
                    <>
                        <Typography sx={{ fontSize: { xs: "20px", sm: "26px", md: "28px" }, color: "#131313", fontFamily: "Satoshi-Bold !important", mt: { xs: "1rem", sm: "30px", md: "50px" }, }}>
                            OTP Verification
                        </Typography>
                        <Box className={classes.otpContainer}>
                            {otp.map((data, index) => (
                                <input
                                    key={index}
                                    type="number"
                                    className={classes.otpInput}
                                    value={data}
                                    onChange={(e) => {
                                        if (+e?.target?.value >= 0) {
                                            handleChange(e.target, index)
                                        } else {
                                            return;
                                        }
                                    }}
                                    maxLength="1"
                                    onFocus={(e) => e.target.select()}
                                    onPaste={handlePaste}
                                />
                            ))}
                        </Box>
                    </>
                }
                children2={
                    <>
                        <Typography
                            sx={{ color: "#8D8D8D", fontSize: { xs: "14px", sm: "14px", md: "16px" }, fontWeight: "500", fontFamily: "Satoshi-Light", margin: { xs: "1.5rem 0 1rem", sm: "2rem 0 1rem", md: "3rem 0 1rem", }, }}>
                            Don't receive the OTP?
                            <span onClick={() => handleResendOtp()} style={{ color: "#8D8D8D", fontSize: "16px", fontWeight: "500", textDecoration: "underline", cursor: "pointer", fontFamily: "Satoshi-Light", }}>
                                Resend OTP
                            </span>
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={handleBack}>
                            <img src="/assets/img/backArrow.svg" />
                            <Typography sx={{ ml: 1, color: "#8D8D8D", fontSize: { xs: "14px", sm: "14px", md: "16px" }, fontWeight: "500", fontFamily: "Satoshi-Medium", }}>
                                Back To login
                            </Typography>
                        </Box>
                    </>
                }
            />
        </>
    );
};

export default OtpVerification;
